var indexOf = [].indexOf;

angular.module('website').controller('BookingModalCtrl', ["$scope", "$modalInstance", "$http", "$timeout", "DataService", "event", "isFreeTrials", "onBookingSuccess", function($scope, $modalInstance, $http, $timeout, DataService, event, isFreeTrials, onBookingSuccess) {
  var bookMember, clearMessages, hiddenFields, inviteToWaitList, onBookingComplete, ref, scrollModal, setLinksTarget;
  $scope.event = event;
  $scope.units = DataService.units;
  $scope.currency = DataService.currency;
  $scope.showInstructor = DataService.gym_config.show_instructor_on_website_calendar;
  $scope.showCapacity = DataService.gym_config.show_capacity_on_website_calendar;
  $scope.allowBookings = DataService.allow_bookings;
  $scope.isZeroBookingEvent = (ref = $scope.event.participant_limit) === 0 || ref === (void 0) || ref === null;
  $scope.contact = {
    contact_information: {}
  };
  hiddenFields = ['prospect_status'];
  $scope.pageParams = {};
  clearMessages = function() {
    $scope.errorMessage = '';
    return $scope.successMessage = '';
  };
  $scope.showContactForm = function() {
    clearMessages();
    $scope.isContactFormDisplaying = true;
    return $http.get(`/gyms/${DataService.gym_id}/forms?contact_type=prospects`).then(function(response) {
      return $scope.forms = _.chain(response.data).map(function(form) {
        var base, name;
        if (form.on_website && form.show_on_new_record) {
          (base = $scope.contact)[name = form.name] || (base[name] = {});
          form.fields = _.filter(form.fields, function(field) {
            var ref1;
            return field.on_prospect && !field.read_only && (ref1 = field.name, indexOf.call(hiddenFields, ref1) < 0);
          });
          return form;
        }
      }).compact().value();
    }, function(response) {
      $scope.isContactFormDisplaying = false;
      return $scope.errorMessage = 'An error occured, please try again later.';
    });
  };
  if (isFreeTrials) {
    $scope.showContactForm();
  }
  $scope.displayMemberForm = function() {
    return $scope.isContactFormDisplaying = false;
  };
  $http.get(`/gyms/${DataService.gym_id}/privacy_policies?filters[policy_context]=gym_website`).then(function(response) {
    $scope.privacyPolicies = response.data.collection;
    setLinksTarget();
    return $scope.contact.privacy_policy_responses_attributes = $scope.privacyPolicies.map(function(item) {
      return {
        privacy_policy_id: item.id,
        accepted: false
      };
    });
  });
  setLinksTarget = function() {
    return $timeout(function() {
      return angular.element('.form-group a').each(function(i, element) {
        return element.target = '_blank';
      });
    });
  };
  $scope.isPrivacyPoliciesFormValid = function() {
    return _.every($scope.contact.privacy_policy_responses_attributes, function(item) {
      return item.accepted;
    });
  };
  $scope.isFieldRequired = function(field) {
    if (field.customizable_required_settings) {
      return field.required_on_website;
    } else {
      return field.required;
    }
  };
  scrollModal = function() {
    return angular.element(".modal").scrollTo(0, 0);
  };
  $scope.isFormReady = function() {
    return !_.find($scope.forms, function(form) {
      return form.on_website && _.find(form.fields, function(field) {
        return field.on_prospect && field.on_website && $scope.isFieldRequired(field) && !field.archived && !$scope.contact[form.name][field.name];
      });
    });
  };
  onBookingComplete = function() {
    var eventParams;
    eventParams = {
      event_name: $scope.event.title,
      event_time: moment(event.start).format()
    };
    return onBookingSuccess(eventParams);
  };
  $scope.saveContact = function() {
    clearMessages();
    $scope.contact.booking = {
      event_id: $scope.event.id
    };
    $scope.isLoading = true;
    return $http.post(`/websites/${DataService.domain}/free_trials`, {
      contact: $scope.contact
    }).then(function(response) {
      var contactResponse;
      contactResponse = response.data.error;
      if (contactResponse.id) {
        onBookingComplete();
        $scope.successMessage = 'Booked successfully';
        return $timeout(function() {
          return $modalInstance.close(contactResponse);
        }, 3000);
      } else {
        $scope.isLoading = false;
        if (_.isString(contactResponse)) {
          $scope.errorMessage = contactResponse;
        } else {
          $scope.forms.forEach(function(form) {
            return $scope.contact[form.name].errors = contactResponse[form.name].errors;
          });
        }
        return scrollModal();
      }
    });
  };
  bookMember = function() {
    var params;
    params = {
      website_id: DataService.domain,
      event_id: $scope.event.id,
      member_email: !$scope.pageParams.matchingContactId && $scope.contact.contact_information.email,
      matching_contact_id: $scope.pageParams.matchingContactId,
      privacy_policy_responses_attributes: $scope.contact.privacy_policy_responses_attributes
    };
    return $http.post("/websites_bookings", params).then(function(response) {
      if (response.data.success) {
        onBookingComplete();
        $scope.successMessage = response.data.success;
        return $timeout(function() {
          return $modalInstance.close(response.data);
        }, 3000);
      } else {
        $scope.isLoading = false;
        $scope.multipleContactsFoundMessage = response.data.error;
        $scope.contactMatches = response.data.matches;
        $scope.bookAndPayOptions = response.data.book_and_pay_options;
        $scope.errorMessage = response.data.error;
        return scrollModal();
      }
    }, function(response) {
      var error;
      $scope.isLoading = false;
      error = response.data.error;
      if (event.open_to_prospects && error === 'No matching customer for the provided email address.') {
        $scope.emailNotFound = true;
        $scope.showContactForm();
        return $scope.contact.contact_information = {
          email: params.member_email
        };
      } else {
        $scope.errorMessage = error;
        return scrollModal();
      }
    });
  };
  inviteToWaitList = function() {
    var params, url;
    url = `/websites/${DataService.domain}/waitlist_attendees`;
    params = {
      contact_email: $scope.contact.contact_information.email,
      event_id: $scope.event.id,
      privacy_policy_responses_attributes: $scope.contact.privacy_policy_responses_attributes
    };
    return $http.post(url, params).then(function(response) {
      $scope.successMessage = "Waitlist joined";
      return $timeout(function() {
        return $modalInstance.close(response.data);
      }, 3000);
    }, function(response) {
      $scope.errorMessage = response.data.error_message;
      $scope.isLoading = false;
      return scrollModal();
    });
  };
  $scope.submit = function() {
    $scope.isLoading = true;
    if ($scope.event.invite_to_waitlist) {
      return inviteToWaitList();
    } else {
      return bookMember();
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
